import React, { Suspense } from 'react';
import { PostFilter } from "../../components/Filter/PostFilter";

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../utils/Search-Params");
require("../../modules/cookie/cookie");

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main" style={{ paddingBottom: "30px" }}>
                <PostFilter />
            </div> 
        </Suspense>
    );
}

export default App;